"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchSections = exports.getPostDetails = exports.getRelatedPosts = exports.getTrending = exports.postSubscribe = exports.postPageView = exports.getMangoTracker = exports.getAssets = exports.getLoadMore = exports.postSearch = exports.getPage = void 0;
const getPage_1 = __importDefault(require("./lib/get/getPage"));
exports.getPage = getPage_1.default;
const postSearch_1 = __importDefault(require("./lib/post/postSearch"));
exports.postSearch = postSearch_1.default;
const getLoadMore_1 = __importDefault(require("./lib/get/getLoadMore"));
exports.getLoadMore = getLoadMore_1.default;
const getAssets_1 = __importDefault(require("./lib/get/getAssets"));
exports.getAssets = getAssets_1.default;
const getMangoTracker_1 = __importDefault(require("./lib/get/getMangoTracker"));
exports.getMangoTracker = getMangoTracker_1.default;
const postPageView_1 = __importDefault(require("./lib/post/postPageView"));
exports.postPageView = postPageView_1.default;
const postSubscribe_1 = __importDefault(require("./lib/post/postSubscribe"));
exports.postSubscribe = postSubscribe_1.default;
const getTrending_1 = __importDefault(require("./lib/get/getTrending"));
exports.getTrending = getTrending_1.default;
const getRelatedPosts_1 = __importDefault(require("./lib/get/getRelatedPosts"));
exports.getRelatedPosts = getRelatedPosts_1.default;
const getPostDetails_1 = __importDefault(require("./lib/get/getPostDetails"));
exports.getPostDetails = getPostDetails_1.default;
const getSearchSections_1 = __importDefault(require("./lib/get/getSearchSections"));
exports.getSearchSections = getSearchSections_1.default;
